import { cn } from "@gymflow/helpers";
import { FormikProvider, useFormik } from "formik";
import { apiV2 } from "libs/api/src/lib/apiV2";
import { useContext } from "react";
import { useTranslation } from "react-i18next";
import { z } from "zod";
import { toFormikValidate, toFormikValidationSchema } from "zod-formik-adapter";

import { queryClient } from "../../../../../../libs/api/src/lib/apiV2/QueryClient";
import { Button, FormInput } from "../../../components/atoms";
import { usePortalRoutes } from "../../../hooks";
import { SessionOverlayContext } from "./SessionOverlayContext";

const trySignInSchema = z.object({
  email: z.string().email(),
});

export function TrySignIn() {
  const { setSessionOverlayState } = useContext(SessionOverlayContext);
  const { isEmbed } = usePortalRoutes();
  const { t } = useTranslation();

  const formik = useFormik({
    initialValues: {
      email: "",
    },
    validationSchema: toFormikValidationSchema(trySignInSchema),
    validate: toFormikValidate(trySignInSchema),
    onSubmit: async (values) => {
      const alreadyRegistered = await queryClient.fetchQuery(
        apiV2.hosted.member.queries.emailExists(values.email),
      );
      if (alreadyRegistered) {
        setSessionOverlayState({
          screen: "sign-in",
          state: {
            email: values.email,
          },
        });
      } else {
        setSessionOverlayState({
          screen: "sign-up",
          state: {
            email: values.email,
          },
        });
      }
    },
  });
  return (
    <FormikProvider value={formik}>
      <div
        className={cn(
          "flex w-full max-w-sm flex-col justify-center gap-8 min-h-fit",
          {
            "justify-start": isEmbed,
          },
        )}
      >
        <div className="flex flex-col items-center gap-6">
          <div className="text-center text-2xl font-bold text-gray-900 dark:text-gray-50">
            {t("page.hostedPages.trySignIn.title")}
          </div>
          <div className="text-center text-sm font-medium text-gray-600 dark:text-gray-400">
            {t("page.hostedPages.trySignIn.description")}
          </div>
        </div>
        <div className="flex flex-col gap-6">
          <FormInput name="email" />
          <div className="pb-8">
            <Button
              intent="primary"
              type="submit"
              className="mt-2 w-full"
              onClick={async () => await formik.submitForm()}
            >
              {t("portal.common.continue")}
            </Button>
          </div>
        </div>
      </div>
    </FormikProvider>
  );
}
